import { useState } from "react";
import lastPlatesDataRaw from "../data/ultimes_matricules.json";

// Dades de matrícules del CSV
const licensePlateData: Record<number, Record<string, string>> = {
  2025: { Gener: "MYF", Febrer: "MYW", Març: "MZS", Abril: "NBL", Maig: "NCJ", Juny: "NDG", Juliol: "NFC", Agost: "NFR", Setembre: "NGJ", Octubre: "NHD", Novembre: "NHX", Desembre: "NJK" },
  2024: { Gener: "MNC", Febrer: "MNT", Març: "MPL", Abril: "MRD", Maig: "MRX", Juny: "MSS", Juliol: "MTK", Agost: "MTW", Setembre: "MVL", Octubre: "MWD", Novembre: "MWV", Desembre: "MXP" },
  2023: { Gener: "MDS", Febrer: "MFG", Març: "MFZ", Abril: "MGN", Maig: "MHG", Juny: "MJB", Juliol: "MJR", Agost: "MKD", Setembre: "MKR", Octubre: "MLH", Novembre: "MLY", Desembre: "MMN" },
  2022: { Gener: "LWD", Febrer: "LWR", Març: "LXD", Abril: "LXS", Maig: "LYJ", Juny: "LYZ", Juliol: "LZP", Agost: "LZZ", Setembre: "MBN", Octubre: "MCB", Novembre: "MCR", Desembre: "MDF" },
  2021: { Gener: "LML", Febrer: "LMX", Març: "LNN", Abril: "LPD", Maig: "LPW", Juny: "LRP", Juliol: "LSG", Agost: "LSR", Setembre: "LTD", Octubre: "LTP", Novembre: "LVD", Desembre: "LVV" },
  2020: { Gener: "LFH", Febrer: "LFY", Març: "LGG", Abril: "LGH", Maig: "LGP", Juny: "LHG", Juliol: "LJD", Agost: "LJR", Setembre: "LKF", Octubre: "LKV", Novembre: "LLJ", Desembre: "LMC" },
  2019: { Gener: "KTJ", Febrer: "KVB", Març: "KVX", Abril: "KWT", Maig: "KXR", Juny: "KYN", Juliol: "KZK", Agost: "KZY", Setembre: "LBN", Octubre: "LCG", Novembre: "LCY", Desembre: "LDR" },
  2018: { Gener: "KHG", Febrer: "KHY", Març: "KJV", Abril: "KKR", Maig: "KLN", Juny: "KMM", Juliol: "KNK", Agost: "KPD", Setembre: "KPS", Octubre: "KRJ", Novembre: "KRZ", Desembre: "KSS" },
  2017: { Gener: "JWN", Febrer: "JXF", Març: "JYB", Abril: "JYT", Maig: "JZP", Juny: "KBM", Juliol: "KCH", Agost: "KCV", Setembre: "KDK", Octubre: "KFC", Novembre: "KFW", Desembre: "KGN" },
  2016: { Gener: "JLN", Febrer: "JMF", Març: "JMY", Abril: "JNR", Maig: "JPK", Juny: "JRG", Juliol: "JRZ", Agost: "JSL", Setembre: "JTB", Octubre: "JTR", Novembre: "JVH", Desembre: "JVZ" },
  2015: { Gener: "JCK", Febrer: "JCY", Març: "JDR", Abril: "JFG", Maig: "JFX", Juny: "JGR", Juliol: "JHJ", Agost: "JHT", Setembre: "JJH", Octubre: "JJW", Novembre: "JKK", Desembre: "JKZ" },
  2014: { Gener: "HVN", Febrer: "HVZ", Març: "HWM", Abril: "HWY", Maig: "HXN", Juny: "HYD", Juliol: "HYT", Agost: "HZB", Setembre: "HZL", Octubre: "HZZ", Novembre: "JBL", Desembre: "JBY" },
  2013: { Gener: "HNT", Febrer: "HPC", Març: "HPN", Abril: "HPY", Maig: "HRK", Juny: "HRX", Juliol: "HSK", Agost: "HSR", Setembre: "HSZ", Octubre: "HTK", Novembre: "HTV", Desembre: "HVF" },
  2012: { Gener: "HJC", Febrer: "HJM", Març: "HKB", Abril: "HKL", Maig: "HKX", Juny: "HLK", Juliol: "HLW", Agost: "HMD", Setembre: "HML", Octubre: "HMT", Novembre: "HNC", Desembre: "HNK" },
  2011: { Gener: "HBP", Febrer: "HCB", Març: "HCR", Abril: "HDC", Maig: "HDR", Juny: "HFF", Juliol: "HFT", Agost: "HGC", Setembre: "HGM", Octubre: "HGX", Novembre: "HHH", Desembre: "HHT" },
  2010: { Gener: "GTC", Febrer: "GTS", Març: "GVM", Abril: "GWC", Maig: "GWV", Juny: "GXP", Juliol: "GYD", Agost: "GYM", Setembre: "GYX", Octubre: "GZJ", Novembre: "GZT", Desembre: "HBG" },
  2009: { Gener: "GKS", Febrer: "GLC", Març: "GLP", Abril: "GMC", Maig: "GMN", Juny: "GNF", Juliol: "GNY", Agost: "GPJ", Setembre: "GPW", Octubre: "GRM", Novembre: "GSC", Desembre: "GSR" },
  2008: { Gener: "FZR", Febrer: "GBN", Març: "GCK", Abril: "GDH", Maig: "GFC", Juny: "GFY", Juliol: "GGV", Agost: "GHG", Setembre: "GHT", Octubre: "GJJ", Novembre: "GJV", Desembre: "GKH" },
  2007: { Gener: "FKY", Febrer: "FLV", Març: "FNB", Abril: "FNZ", Maig: "FRC", Juny: "FSJ", Juliol: "FTP", Agost: "FVJ", Setembre: "FWC", Octubre: "FXB", Novembre: "FXY", Desembre: "FYY" },
  2006: { Gener: "DVW", Febrer: "DWT", Març: "DXZ", Abril: "DYY", Maig: "FBC", Juny: "FCJ", Juliol: "FDP", Agost: "FFK", Setembre: "FGF", Octubre: "FHD", Novembre: "FJD", Desembre: "FKC" },
  2005: { Gener: "DFZ", Febrer: "DGX", Març: "DHZ", Abril: "DKB", Maig: "DLD", Juny: "DMJ", Juliol: "DNP", Agost: "DPK", Setembre: "DRG", Octubre: "DSC", Novembre: "DTB", Desembre: "DVB" },
  2004: { Gener: "CRV", Febrer: "CSS", Març: "CTT", Abril: "CVR", Maig: "CWR", Juny: "CXT", Juliol: "CYY", Agost: "CZP", Setembre: "DBJ", Octubre: "DCH", Novembre: "DDG", Desembre: "DFF" },
  2003: { Gener: "CDV", Febrer: "CFM", Març: "CGJ", Abril: "CHF", Maig: "CJC", Juny: "CKB", Juliol: "CLD", Agost: "CLV", Setembre: "CMM", Octubre: "CNK", Novembre: "CPF", Desembre: "CRC" },
  2002: { Gener: "BSL", Febrer: "BTF", Març: "BTZ", Abril: "BVW", Maig: "BWT", Juny: "BXP", Juliol: "BYP", Agost: "BZF", Setembre: "BZV", Octubre: "CBP", Novembre: "CCH", Desembre: "CDC" },
  2001: { Gener: "BFJ", Febrer: "BGF", Març: "BHG", Abril: "BJC", Maig: "BKB", Juny: "BLC", Juliol: "BMF", Agost: "BMW", Setembre: "BNL", Octubre: "BPG", Novembre: "BRB", Desembre: "BRT" },
  2000: { Gener: "---", Febrer: "---", Març: "---", Abril: "---", Maig: "---", Juny: "---", Juliol: "---", Agost: "---", Setembre: "BBJ", Octubre: "BCD", Novembre: "BCY", Desembre: "BDR" }
};

// Dades de les últimes matrícules del CSV
interface PlateRecord {
  date: string; // DD/MM/YYYY
  plate: string; // XX** YYY
  brand: string;
  model: string;
}

const lastPlatesData: PlateRecord[] = lastPlatesDataRaw as PlateRecord[];

const months = ["Gener", "Febrer", "Març", "Abril", "Maig", "Juny", "Juliol", "Agost", "Setembre", "Octubre", "Novembre", "Desembre"];

// Funció per extreure el número de la matrícula (els primers 2 dígits)
const extractPlateNumber = (plate: string): number => {
  const match = plate.match(/^(\d{2})\*\*/);
  return match ? parseInt(match[1], 10) : 0;
};

// Funció per parsejar la data
const parseDate = (dateStr: string): Date => {
  const [day, month, year] = dateStr.split("/").map(Number);
  return new Date(year, month - 1, day);
};

// Funció per calcular la data basant-se en la posició entre matrícules conegudes
const calculateDateFromPlates = (
  plateNumber: number,
  letters: string
): { year: number; month: string; day?: number } | null => {
  // Filtrar matrícules amb el mateix codi de lletres
  const matchingPlates = lastPlatesData
    .filter((record) => {
      const plateLetters = record.plate.split(" ")[1];
      return plateLetters === letters;
    })
    .map((record) => {
      const date = parseDate(record.date);
      return {
        ...record,
        plateNum: extractPlateNumber(record.plate),
        date,
        day: date.getDate(),
        monthIndex: date.getMonth(),
        year: date.getFullYear(),
      };
    })
    .sort((a, b) => a.plateNum - b.plateNum); // Ordenar per número de matrícula

  if (matchingPlates.length === 0) {
    return null;
  }

  // Trobar entre quines dues matrícules es troba
  let prevPlate = matchingPlates[0];
  let nextPlate = matchingPlates[matchingPlates.length - 1];
  let foundBetween = false;

  for (let i = 0; i < matchingPlates.length - 1; i++) {
    if (plateNumber >= matchingPlates[i].plateNum && plateNumber <= matchingPlates[i + 1].plateNum) {
      prevPlate = matchingPlates[i];
      nextPlate = matchingPlates[i + 1];
      foundBetween = true;
      break;
    }
  }

  // Si la matrícula és anterior a totes, usar la primera
  if (plateNumber < matchingPlates[0].plateNum) {
    prevPlate = matchingPlates[0];
    nextPlate = matchingPlates[0];
  }

  // Si la matrícula és posterior a totes, calcular una data futura
  if (plateNumber > matchingPlates[matchingPlates.length - 1].plateNum) {
    const lastPlate = matchingPlates[matchingPlates.length - 1];
    const plateDiff = plateNumber - lastPlate.plateNum;
    
    // Estimar la progressió de matrícules per dia
    // Si hi ha múltiples matrícules, calcular la mitjana de progressió
    let avgPlatesPerDay = 1; // Valor per defecte
    if (matchingPlates.length >= 2) {
      // Calcular la progressió mitjana entre matrícules consecutives
      let totalDays = 0;
      let totalPlateDiff = 0;
      for (let i = 1; i < matchingPlates.length; i++) {
        const daysDiff = Math.abs(
          (matchingPlates[i].date.getTime() - matchingPlates[i - 1].date.getTime()) / (1000 * 60 * 60 * 24)
        );
        const plateDiff = matchingPlates[i].plateNum - matchingPlates[i - 1].plateNum;
        if (daysDiff > 0) {
          totalDays += daysDiff;
          totalPlateDiff += plateDiff;
        }
      }
      if (totalDays > 0) {
        avgPlatesPerDay = totalPlateDiff / totalDays;
      }
    }
    
    // Calcular els dies estimats des de l'última matrícula
    const estimatedDays = Math.max(1, Math.round(plateDiff / Math.max(0.1, avgPlatesPerDay)));
    
    // Crear una data futura basant-nos en l'última matrícula + dies estimats
    const futureDate = new Date(lastPlate.date);
    futureDate.setDate(futureDate.getDate() + estimatedDays);
    
    // Assegurar-nos que la data sigui futura (almenys 1 dia després de l'última)
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    if (futureDate <= lastPlate.date) {
      futureDate.setDate(lastPlate.date.getDate() + 1);
    }
    
    return {
      year: futureDate.getFullYear(),
      month: months[futureDate.getMonth()],
      day: futureDate.getDate(),
    };
  }

  // Si les dues matrícules són del mateix mes i any
  if (prevPlate.year === nextPlate.year && prevPlate.monthIndex === nextPlate.monthIndex) {
    const monthName = months[prevPlate.monthIndex];
    
    // Interpolar el dia si hi ha diferència
    let estimatedDay: number | undefined = undefined;
    if (prevPlate.plateNum !== nextPlate.plateNum && prevPlate.day !== nextPlate.day) {
      const ratio = (plateNumber - prevPlate.plateNum) / (nextPlate.plateNum - prevPlate.plateNum);
      estimatedDay = Math.round(prevPlate.day + (nextPlate.day - prevPlate.day) * ratio);
      estimatedDay = Math.max(1, Math.min(31, estimatedDay));
    } else {
      estimatedDay = prevPlate.day;
    }

    return {
      year: prevPlate.year,
      month: monthName,
      day: estimatedDay,
    };
  }

  // Si estan en mesos diferents, determinar quin mes correspon
  // Si està més a prop de la primera, usar la primera data
  // Si està més a prop de la segona, usar la segona data
  const distanceToPrev = Math.abs(plateNumber - prevPlate.plateNum);
  const distanceToNext = Math.abs(plateNumber - nextPlate.plateNum);

  const selectedPlate = distanceToPrev <= distanceToNext ? prevPlate : nextPlate;
  const monthName = months[selectedPlate.monthIndex];

  return {
    year: selectedPlate.year,
    month: monthName,
    day: selectedPlate.day,
  };
};

export const CalculateLicensePlate = () => {
  const [mode, setMode] = useState<"date" | "plate">("date"); // "date" = calcular data, "plate" = calcular matrícula
  const [plateNumbers, setPlateNumbers] = useState("");
  const [plateLetters, setPlateLetters] = useState("");
  const currentDate = new Date();
  const [selectedYear, setSelectedYear] = useState<number>(2025);
  const [selectedMonth, setSelectedMonth] = useState<string>("");
  const [selectedDay, setSelectedDay] = useState<number>(1);
  const [result, setResult] = useState<{ year: number; month: string; day?: number } | { plate: string } | null>(null);
  const [error, setError] = useState("");

  // Funció per calcular la matrícula futura
  const handleCalculatePlate = () => {
    setError("");
    setResult(null);

    if (!selectedMonth) {
      setError("Selecciona un mes.");
      return;
    }

    if (selectedDay < 1 || selectedDay > 31) {
      setError("El dia ha de ser entre 1 i 31.");
      return;
    }

    // Validar que la data sigui futura
    const selectedDate = new Date(selectedYear, months.indexOf(selectedMonth), selectedDay);
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    
    if (selectedDate <= today) {
      setError("La data ha de ser futura.");
      return;
    }

    // Per a dates futures, calcular basant-nos en la progressió observada
    // Trobar l'última matrícula coneguda abans de la data seleccionada
    const allPlatesWithDates = lastPlatesData
      .map((record) => {
        const date = parseDate(record.date);
        return {
          ...record,
          plateNum: extractPlateNumber(record.plate),
          plateLetters: record.plate.split(" ")[1],
          date,
          day: date.getDate(),
          monthIndex: date.getMonth(),
          year: date.getFullYear(),
        };
      })
      .filter((p) => p.date <= selectedDate)
      .sort((a, b) => {
        // Ordenar per data (més recent primer)
        if (a.date.getTime() !== b.date.getTime()) {
          return b.date.getTime() - a.date.getTime();
        }
        // Si mateixa data, ordenar per número (més alt primer)
        return b.plateNum - a.plateNum;
      });

    if (allPlatesWithDates.length === 0) {
      setError("No hi ha dades suficients per calcular la matrícula futura.");
      return;
    }

    // Trobar l'última matrícula coneguda
    const lastKnownPlate = allPlatesWithDates[0];
    const daysSinceLastPlate = Math.floor(
      (selectedDate.getTime() - lastKnownPlate.date.getTime()) / (1000 * 60 * 60 * 24)
    );

    // Calcular la progressió mitjana de matrícules per dia
    // Analitzar les últimes matrícules per entendre la progressió
    let avgPlatesPerDay = 0.5; // Valor per defecte conservador
    if (allPlatesWithDates.length >= 2) {
      let totalDays = 0;
      let totalPlateDiff = 0;
      // Analitzar les últimes 10 matrícules per calcular la progressió
      const recentPlates = allPlatesWithDates.slice(0, Math.min(10, allPlatesWithDates.length));
      for (let i = 0; i < recentPlates.length - 1; i++) {
        const daysDiff = Math.abs(
          (recentPlates[i].date.getTime() - recentPlates[i + 1].date.getTime()) / (1000 * 60 * 60 * 24)
        );
        // Si les matrícules tenen el mateix codi de lletres, calcular la diferència
        if (recentPlates[i].plateLetters === recentPlates[i + 1].plateLetters) {
          const plateDiff = Math.abs(recentPlates[i].plateNum - recentPlates[i + 1].plateNum);
          if (daysDiff > 0 && plateDiff > 0) {
            totalDays += daysDiff;
            totalPlateDiff += plateDiff;
          }
        }
      }
      if (totalDays > 0) {
        avgPlatesPerDay = totalPlateDiff / totalDays;
      }
    }

    // Estimar el número de matrícula basant-nos en la progressió
    const estimatedPlateNum = Math.min(99, Math.round(lastKnownPlate.plateNum + (daysSinceLastPlate * avgPlatesPerDay) + 5));
    let estimatedNumber = estimatedPlateNum.toString().padStart(2, "0") + "**";

    // Determinar el codi de lletres per a la data seleccionada
    // Per a dates futures, buscar l'últim codi real usat i assegurar que la matrícula sigui futura
    let code: string | undefined;
    
    // Buscar l'últim codi real usat abans de la data seleccionada
    const selectedMonthIndex = months.indexOf(selectedMonth);
    const platesBeforeSelectedDate = allPlatesWithDates.filter(p => {
      return p.year < selectedYear || (p.year === selectedYear && p.monthIndex < selectedMonthIndex) ||
             (p.year === selectedYear && p.monthIndex === selectedMonthIndex && p.date < selectedDate);
    });
    
    const lastCodeBeforeDate = platesBeforeSelectedDate.length > 0 
      ? platesBeforeSelectedDate[0].plateLetters 
      : lastKnownPlate.plateLetters;
    
    if (selectedYear === 2026) {
      // Per a 2026, buscar el codi teòric de matricules.csv (que seria el de 2025)
      // Però assegurar-nos que la matrícula calculada sigui clarament futura
      const year2025Data = licensePlateData[2025];
      if (year2025Data && year2025Data[selectedMonth] && year2025Data[selectedMonth] !== "---") {
        code = year2025Data[selectedMonth];
      } else {
        setError(`No es pot estimar el codi per a ${selectedMonth} de ${selectedYear}.`);
        return;
      }
    } else {
      const yearData = licensePlateData[selectedYear];
      if (!yearData) {
        setError(`No hi ha dades per a l'any ${selectedYear}.`);
        return;
      }

      code = yearData[selectedMonth];
      if (!code || code === "---") {
        setError(`No hi ha dades per a ${selectedMonth} de ${selectedYear}.`);
        return;
      }
    }

    // IMPORTANT: Si el codi calculat és el mateix que l'últim codi conegut abans de la data,
    // assegurar-nos que el número sigui MOLT més alt perquè sigui clarament futura
    // Això és especialment important per a 2026, on el codi pot ser el mateix que 2025
    if (code === lastCodeBeforeDate || code === lastKnownPlate.plateLetters) {
      // Si la data és futura i el codi és el mateix, la matrícula ha de ser molt més alta
      const lastPlateWithSameCode = allPlatesWithDates.find(p => p.plateLetters === code);
      if (lastPlateWithSameCode) {
        const minIncrement = Math.max(15, Math.ceil(daysSinceLastPlate * Math.max(avgPlatesPerDay, 0.5)));
        const estimated = Math.min(99, lastPlateWithSameCode.plateNum + minIncrement);
        estimatedNumber = estimated.toString().padStart(2, "0") + "**";
      } else {
        // Si no hi ha matrícules amb aquest codi, començar des de 00**
        estimatedNumber = "00**";
      }
    } else {
      // Si el codi és diferent, començar des de 00** o un número baix
      estimatedNumber = "00**";
    }

    setResult({
      plate: `${estimatedNumber} ${code}`,
    });
  };

  const handleCalculate = () => {
    if (mode === "plate") {
      handleCalculatePlate();
      return;
    }

    setError("");
    setResult(null);

    // Netejar les entrades
    const numbers = plateNumbers.trim();
    const letters = plateLetters.trim().toUpperCase();

    // Validar format
    if (!/^\d{4}$/.test(numbers)) {
      setError("Format incorrecte. Introdueix 4 números (ex: 1234).");
      return;
    }

    if (!/^[A-Z]{3}$/.test(letters)) {
      setError("Format incorrecte. Introdueix 3 lletres (ex: BBB).");
      return;
    }

    const plateNumber = parseInt(numbers, 10);
    const plateNumberFirstTwo = Math.floor(plateNumber / 100); // Primeres 2 xifres per comparar amb XX**

    // Primer intentar calcular basant-nos en les matrícules conegudes de ultimes_matricules.csv
    const calculatedDate = calculateDateFromPlates(plateNumberFirstTwo, letters);

    if (calculatedDate) {
      setResult(calculatedDate);
      return;
    }

    // Si no hi ha dades a ultimes_matricules.csv, buscar a la taula de mesos/anys (matricules.csv)
    // Buscar el codi exacte primer
    let foundYear: number | null = null;
    let foundMonth: string | null = null;

    for (const [yearStr, monthsData] of Object.entries(licensePlateData)) {
      const year = parseInt(yearStr);
      for (const [month, code] of Object.entries(monthsData)) {
        if (code === letters && code !== "---" && code.length === 3) {
          foundYear = year;
          foundMonth = month;
          break;
        }
      }
      if (foundYear && foundMonth) break;
    }

    // Si no es troba el codi exacte, buscar el més proper alfabèticament
    if (!foundYear || !foundMonth) {
      // Recopilar tots els codis vàlids ordenats
      const allCodes: Array<{ code: string; year: number; month: string }> = [];
      for (const [yearStr, monthsData] of Object.entries(licensePlateData)) {
        const year = parseInt(yearStr);
        for (const [month, code] of Object.entries(monthsData)) {
          if (code !== "---" && code.length === 3) {
            allCodes.push({ code, year, month });
          }
        }
      }

      // Ordenar alfabèticament
      allCodes.sort((a, b) => a.code.localeCompare(b.code));

      // Trobar el codi més proper
      let closestIndex = -1;
      
      // Buscar el codi exacte o el més proper
      for (let i = 0; i < allCodes.length; i++) {
        if (allCodes[i].code === letters) {
          closestIndex = i;
          break;
        }
        // Si el codi buscat és menor que el codi actual, hem trobat la posició
        if (letters < allCodes[i].code) {
          // Usar el codi anterior (més proper) o el actual
          if (i > 0) {
            const prevDist = Math.abs(allCodes[i - 1].code.localeCompare(letters));
            const currDist = Math.abs(allCodes[i].code.localeCompare(letters));
            closestIndex = prevDist <= currDist ? i - 1 : i;
          } else {
            closestIndex = i;
          }
          break;
        }
      }

      // Si no s'ha trobat, usar l'últim codi
      if (closestIndex === -1 && allCodes.length > 0) {
        closestIndex = allCodes.length - 1;
      }

      if (closestIndex >= 0 && closestIndex < allCodes.length) {
        foundYear = allCodes[closestIndex].year;
        foundMonth = allCodes[closestIndex].month;
      }
    }

    if (!foundYear || !foundMonth) {
      setError(`No s'ha trobat el codi "${letters}" a la base de dades. Les matrícules disponibles són del 2000 al 2025.`);
      return;
    }

    // Mostrar només mes i any si no hi ha dades per calcular el dia
    setResult({
      year: foundYear,
      month: foundMonth,
    });
  };

  const handleNumbersKeyPress = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter" && plateNumbers.length === 4) {
      document.getElementById("plate-letters")?.focus();
    }
  };

  const handleLettersKeyPress = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter" && plateLetters.length === 3) {
      handleCalculate();
    }
  };

  const handleNumbersChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value.replace(/\D/g, "").slice(0, 4);
    setPlateNumbers(value);
    if (value.length === 4) {
      document.getElementById("plate-letters")?.focus();
    }
  };

  const handleLettersChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value.replace(/[^A-Za-z]/g, "").toUpperCase().slice(0, 3);
    setPlateLetters(value);
  };

  const formatDate = (year: number, month: string, day?: number) => {
    if (day) {
      return `${day} de ${month} de ${year}`;
    }
    return `${month} de ${year}`;
  };

  return (
    <div className="w-full">
      <div className="mb-8 text-center">
        <h1 className="text-3xl sm:text-4xl font-bold mb-2 text-foreground">
          Calculadora de matrícula
        </h1>
        <p className="text-sm sm:text-base text-muted-foreground font-light">
          {mode === "date" 
            ? "Introdueix una matrícula espanyola per conèixer la data aproximada de matriculació"
            : "Introdueix una data de matriculació per conèixer la matrícula aproximada"}
        </p>
      </div>

      <div className="max-w-2xl mx-auto">
        <div className="bg-card rounded-2xl border-2 border-border p-6 sm:p-8 shadow-sm">
          <div className="space-y-6">
            {/* Toggle entre modes */}
            <div className="flex items-center justify-center gap-4 mb-6">
              <button
                onClick={() => {
                  setMode("date");
                  setResult(null);
                  setError("");
                  setPlateNumbers("");
                  setPlateLetters("");
                }}
                className={`px-6 py-2 rounded-lg font-semibold transition-colors ${
                  mode === "date"
                    ? "bg-foreground text-background"
                    : "bg-secondary text-secondary-foreground hover:bg-secondary/80"
                }`}
              >
                Calcular data
              </button>
              <button
                onClick={() => {
                  setMode("plate");
                  setResult(null);
                  setError("");
                  setPlateNumbers("");
                  setPlateLetters("");
                }}
                className={`px-6 py-2 rounded-lg font-semibold transition-colors ${
                  mode === "plate"
                    ? "bg-foreground text-background"
                    : "bg-secondary text-secondary-foreground hover:bg-secondary/80"
                }`}
              >
                Calcular matrícula
              </button>
            </div>

            {/* Input segons el mode */}
            {mode === "date" ? (
              <div>
                <label className="block text-sm font-medium text-muted-foreground mb-2">
                  Matrícula
                </label>
                <div className="bg-secondary p-4 sm:p-6 rounded-xl space-y-4">
                  <div className="flex items-center justify-center gap-3 sm:gap-4">
                    <input
                      id="plate-numbers"
                      type="text"
                      value={plateNumbers}
                      onChange={handleNumbersChange}
                      onKeyPress={handleNumbersKeyPress}
                      placeholder="1234"
                      className="flex-1 max-w-[160px] sm:max-w-[200px] px-6 sm:px-8 py-5 sm:py-6 text-2xl sm:text-3xl border-2 border-border rounded-xl bg-background text-foreground focus:outline-none focus:ring-2 focus:ring-ring focus:border-transparent transition-all font-mono text-center font-bold"
                      maxLength={4}
                      inputMode="numeric"
                    />
                    <span className="text-muted-foreground text-3xl sm:text-4xl font-bold">-</span>
                    <input
                      id="plate-letters"
                      type="text"
                      value={plateLetters}
                      onChange={handleLettersChange}
                      onKeyPress={handleLettersKeyPress}
                      placeholder="BBB"
                      className="flex-1 max-w-[140px] sm:max-w-[180px] px-6 sm:px-8 py-5 sm:py-6 text-2xl sm:text-3xl border-2 border-border rounded-xl bg-background text-foreground focus:outline-none focus:ring-2 focus:ring-ring focus:border-transparent transition-all font-mono uppercase text-center font-bold"
                      maxLength={3}
                    />
                  </div>
                  <div className="flex justify-center">
                  <button
                    onClick={handleCalculate}
                      className="max-w-[340px] sm:max-w-[420px] w-full px-6 py-3 sm:py-4 bg-foreground text-background rounded-xl text-lg sm:text-xl font-bold hover:opacity-80 transition-opacity focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 focus:ring-offset-background"
                    aria-label="Calcular"
                  >
                    Calcular
                  </button>
                  </div>
                </div>
              </div>
            ) : (
              <div>
                <label className="block text-sm font-medium text-muted-foreground mb-2">
                  Data de matriculació futura
                </label>
                <div className="bg-secondary p-4 rounded-xl space-y-3">
                  <div className="grid grid-cols-3 gap-2">
                    <select
                      value={selectedYear}
                      onChange={(e) => setSelectedYear(parseInt(e.target.value))}
                      className="px-3 py-3 text-base border-2 border-border rounded-lg bg-background text-foreground focus:outline-none focus:ring-2 focus:ring-ring focus:border-transparent transition-all w-full text-center font-medium"
                    >
                      <option value={2025}>2025</option>
                      <option value={2026}>2026</option>
                    </select>
                    <select
                      value={selectedMonth}
                      onChange={(e) => {
                        setSelectedMonth(e.target.value);
                        // Resetear el dia quan canvia el mes
                        if (e.target.value) {
                          const daysInMonth = new Date(selectedYear, months.indexOf(e.target.value) + 1, 0).getDate();
                          if (selectedDay > daysInMonth) {
                            setSelectedDay(daysInMonth);
                          }
                        }
                      }}
                      className="px-3 py-3 text-base border-2 border-border rounded-lg bg-background text-foreground focus:outline-none focus:ring-2 focus:ring-ring focus:border-transparent transition-all w-full text-center font-medium"
                    >
                      <option value="">Mes</option>
                      {months.map((month) => (
                        <option key={month} value={month}>
                          {month}
                        </option>
                      ))}
                    </select>
                    <select
                      value={selectedDay}
                      onChange={(e) => setSelectedDay(parseInt(e.target.value))}
                      disabled={!selectedMonth}
                      className="px-3 py-3 text-base border-2 border-border rounded-lg bg-background text-foreground focus:outline-none focus:ring-2 focus:ring-ring focus:border-transparent transition-all disabled:bg-muted disabled:text-muted-foreground w-full text-center font-medium"
                    >
                      {selectedMonth && Array.from({ length: new Date(selectedYear, months.indexOf(selectedMonth) + 1, 0).getDate() }, (_, i) => i + 1).map((day) => (
                        <option key={day} value={day}>
                          {day}
                        </option>
                      ))}
                      {!selectedMonth && <option value="">Dia</option>}
                    </select>
                  </div>
                  <button
                    onClick={handleCalculate}
                    className="w-full px-6 py-3 bg-foreground text-background rounded-lg font-semibold hover:opacity-80 transition-opacity focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 focus:ring-offset-background text-base"
                    aria-label="Calcular"
                  >
                    Calcular
                  </button>
                </div>
              </div>
            )}

            {/* Resultat */}
            {result && (
              <div className="bg-green-50 dark:bg-green-950/40 border-2 border-green-200 dark:border-green-900 rounded-xl p-6">
                <div className="text-center">
                  <div className="text-4xl mb-4">✅</div>
                  {mode === "date" ? (
                    <>
                      <p className="text-sm text-muted-foreground mb-2">Data aproximada:</p>
                      <div className="text-2xl sm:text-3xl font-bold text-green-800 dark:text-green-300">
                        {"year" in result ? formatDate(result.year, result.month, result.day) : ""}
                      </div>
                      {"year" in result && result.day ? (
                        <p className="mt-3 text-xs text-green-700 dark:text-green-400">
                          (Data aproximada calculada basant-se en matrícules conegudes)
                        </p>
                      ) : "year" in result ? (
                        <p className="mt-3 text-xs text-green-700 dark:text-green-400">
                          (Només es pot determinar el mes i any. El dia no està disponible per a aquesta matrícula.)
                        </p>
                      ) : null}
                    </>
                  ) : (
                    <>
                      <p className="text-sm text-muted-foreground mb-2">Matrícula aproximada:</p>
                      <div className="text-2xl sm:text-3xl font-bold text-green-800 dark:text-green-300 font-mono">
                        {"plate" in result ? result.plate : ""}
                      </div>
                      <p className="mt-3 text-xs text-green-700 dark:text-green-400">
                        (Matrícula aproximada calculada basant-se en les dades disponibles)
                      </p>
                    </>
                  )}
                </div>
              </div>
            )}

            {/* Error */}
            {error && (
              <div className="bg-red-50 dark:bg-red-950/40 border-2 border-red-200 dark:border-red-900 rounded-xl p-6">
                <div className="text-center">
                  <div className="text-4xl mb-4">❌</div>
                  <p className="text-sm font-medium text-red-800 dark:text-red-300">{error}</p>
                </div>
              </div>
            )}

            {/* Informació */}
            <div className="bg-blue-50 border border-blue-200 rounded-xl p-4">
              <p className="text-xs text-blue-800 leading-relaxed">
                <strong>Nota:</strong> Aquesta calculadora utilitza les dades de matrícules conegudes per estimar el dia aproximat de matriculació. 
                La data exacta pot variar segons la província i altres factors. El mes i any són exactes, mentre que el dia és una estimació.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
